import { headers, dataURItoBlob } from '@modules/rest'

import * as get from '@graphql/middleware/queries'
import request from '@graphql/middleware'

export async function getPhoto (getters) {
  const employeeId = getters.getEmployeeUuid

  const [ err, data ] = await request(get.GetPhoto, { employeeId })
  const { photo } = data.employee || {}

  return [ err, photo ]
}

export async function uploadPhoto (getters, photo) {
  const host = import.meta.env.VITE_MIDDLEWARE_URL

  const companyUuid = getters.getCompanyUuid
  const employeeId = getters.getEmployeeUuid

  const body = new FormData()

  body.append('photo', dataURItoBlob(photo))

  return fetch(`${host}/employees/proxy/companies/${companyUuid}/employees/${employeeId}/photo/employee`, {
    method: 'POST',
    body,
    headers: headers([ 'Authorization', 'Accept' ])
  })
    .then(response => { if (!response.ok) throw response; return response.json() })
    .then(({ data }) => [ false, data ])
    .catch(err => err.json()
      .then(({ data }) => [ data, null ])
    )
}

export async function removePhoto (getters) {
  const host = import.meta.env.VITE_MIDDLEWARE_URL
  const companyUuid = getters.getCompanyUuid
  const employeeId = getters.getEmployeeUuid

  const url = `${host}/employees/proxy/companies/${companyUuid}/employees/${employeeId}/photo/employee`

  try {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: headers([ 'Authorization', 'Accept' ])
    })

    const data = await response.json()
    return [ null, data ]
  } catch (err) {
    return [ err, null ]
  }
}
